import { FunctionComponent } from 'react';
import { TransactionDataInfo } from '../models/transaction-data-info.model';

interface Props {
    transactionData: TransactionDataInfo;
    onClicked?: (transactionData: TransactionDataInfo) => void;
}

const TransactionDataCard: FunctionComponent<Props> = ({ transactionData, onClicked }) => {
    return (
        <div className="building-card" onClick={() => onClicked && onClicked(transactionData)}>
            <div className="name">{transactionData.propertyName}</div>
            <div className="address">{transactionData.address}</div>
            <hr />
            <div>
                <span className="title">Year Of Completion</span>
                <span className="value">{transactionData.yearBuilt}</span>
            </div>
            <div>
                <span className="title">Land Tenure</span>
                <span className="value">{transactionData.yearBuilt}</span>
            </div>
            <div>
                <span className="title">Site Area (sqft)</span>
                <span className="value"></span>
            </div>
            <div>
                <span className="title">NLA (sqft)</span>
                <span className="value"></span>
            </div>
            <div>
                <span className="title">Carpark Lots</span>
                <span className="value"></span>
            </div>
            <div>
                <span className="title">Selector</span>
                <span className="value">{[transactionData.mainSector, transactionData.subSector].join(', ')}</span>
            </div>
            <div>
                <span className="title">Major Tenants</span>
                <span className="value">{transactionData.tenancy}</span>
            </div>
        </div>
    );
};

export default TransactionDataCard;
